// extracted by mini-css-extract-plugin
export default {"marquee":"Home_marquee__QC4Sz"};